import React, { useState } from "react";
import RewardsPerLevelCard from "./RewardsPerLevelCard";
import ButtonWithStyle from "../../HOCs/ButtonWithStyle/ButtonWithStyle";
import LevelRewards from "./forms/LevelRewards";
import { Paper } from "@material-ui/core";

const useStyle = {
	paper: {
		minWidth: "200px",
		maxWidth: "250px",
		border: "1px solid",
		margin: "0 5px",
	},
};
const RewardsPerLevelDisplay = ({ rewardsPerLevel, deleteReward, label, level, style = {} }) => {
	const [isAdding, setIsAdding] = useState(false);

	return (
		<Paper elevation={3} style={{ ...useStyle.paper, ...style }}>
			{isAdding ? (
				<LevelRewards
					cancelSubmit={() => {
						setIsAdding(false);
					}}
					level={level}
				/>
			) : (
				<ButtonWithStyle
					onClick={() => {
						setIsAdding(true);
					}}
				>
					Agregar a {label}
				</ButtonWithStyle>
			)}
			<hr />
			{rewardsPerLevel.map((reward, index) => {
				return (
					<RewardsPerLevelCard
						key={reward.item._id}
						reward={reward}
						deleteReward={() => {
							if (!window.confirm("Desea eliminar este premio")) return;
							deleteReward({ level, index });
						}}
					/>
				);
			})}
		</Paper>
	);
};

export default RewardsPerLevelDisplay;
